import parser from 'html-react-parser'

const WPHtmlBlock = ({ block }) => {
  if (!block.innerHTML) {
    return null
  }
  return parser(block.innerHTML)
}

export default WPHtmlBlock
